module.exports = __webpack_public_path__ + "img/about-hero-mobile.61b40720.svg";